import React, { useCallback, useEffect, useRef, useState } from "react";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Select from "react-select";
import {
  backButtonHandler,
  deleteLaborRule,
  getAccrualTypes,
  getSetupDetails,
  savePayrollFreq,
  saveSetupWizardForm,
} from "../../../Redux/actions";

import SWInterface from "../../Components/Layout/SWInterface";
import ModelContainer from "../../Components/ModelContainer";
import ErrorContainer from "../../Components/ErrorContainer";
import LeaveRule from "../Rules/LeaveRule";
import OvertimeRule from "../Rules/OvertimeRule";
import AllowanceRule from "../Rules/AllowanceRule";
import BlackOutDateRanges from "../Rules/BlackOutDateRanges";
import IncentiveRule from "../Rules/IncentiveRule";
import PerformanceRule from "../Rules/PerformanceRule";
import Paginate from "../../Components/Paginate";
import BtmButtons from "../../Components/BtmButtons";

const schema = yup
  .object({
    id: yup.string(),
    payroll_name: yup.string().required(),
    payroll_frequency_id: yup.string().required(),
    interim_period_ending_date: yup.string().when("payroll_frequency_id", {
      is: "1",
      then: yup.string().required(),
    }),
    final_period_ending_date: yup.string().required(),
  })
  .required();
const SetupWizardFour = (params) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const {
    account,
    rules,
    payrollFrequencies,
    period2EndingDates,
    period1EndingDates,
    frequency: totalFrequencies,
    leave_claim_rules,
    performance_alert_rules,
    allowance_rules,
    black_out_rules,
    overtime_rules,
    incentive_rules,
    work_weeks,
  } = useSelector((state) => state.authReducer.setup_wizard_details);
  const { user } = useSelector((state) => state.authReducer.user_details);
  const initialForm = {
    id: "",
    payroll_name: "",
    payroll_frequency_id: "",
    interim_period_ending_date: "",
    final_period_ending_date: "",
  };
  const initialDeleteForm = {
    id: "",
    rule: "",
  };
  const {
    register,
    formState: { errors },
    handleSubmit,
    control,
    setValue,
    reset,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: initialForm,
    mode: "all",
    reValidateMode: "onChange",
  });

  const [deleteRuleModal, setDeleteRuleModal] = useState(false);
  const [deleteForm, setDeleteForm] = useState(initialDeleteForm);

  const [payrollModal, setPayrollModal] = useState(false);
  const [rulesArr, setRulesArr] = useState([]);
  const [selectedRules, setSelectedRules] = useState([]);
  const [inputForm, setInputForm] = useState(initialForm);

  const changeInputHandler = (input, val) => {
    setValue(input, val);
    setInputForm((prevState) => ({ ...prevState, [input]: val }));
  };

  useEffect(() => {
    if (user?.merchant?.parent_merchant_id > 0) {
      dispatch(backButtonHandler());
    } else {
      dispatch(getSetupDetails(3));
      dispatch(getAccrualTypes(0));
    }
  }, []);
  useEffect(() => {
    if (rules && rules !== null) {
      let newSelectedRuleArr = [];
      let newRulesArr = [];
      Object.keys(rules).map((rule) => {
        const newItem = { value: rule, label: rules[rule] };
        newRulesArr.push(newItem);
        if (
          leave_claim_rules &&
          leave_claim_rules.length > 0 &&
          rule == "leave_claim"
        ) {
          newSelectedRuleArr.push(newItem);
        }
        if (
          performance_alert_rules &&
          performance_alert_rules.length > 0 &&
          rule == "performance"
        ) {
          newSelectedRuleArr.push(newItem);
        }
        if (
          allowance_rules &&
          allowance_rules.length > 0 &&
          rule == "allowance"
        ) {
          newSelectedRuleArr.push(newItem);
        }
        if (
          black_out_rules &&
          black_out_rules.length > 0 &&
          rule == "black_out"
        ) {
          newSelectedRuleArr.push(newItem);
        }
        if (overtime_rules && overtime_rules.length > 0 && rule == "overtime") {
          newSelectedRuleArr.push(newItem);
        }
        if (
          incentive_rules &&
          incentive_rules.length > 0 &&
          rule == "incentive"
        ) {
          newSelectedRuleArr.push(newItem);
        }
      });
      setRulesArr(newRulesArr);
      setSelectedRules(newSelectedRuleArr);
    }
  }, [rules]);

  const initialModalState = () => {
    setInputForm(initialForm);
    reset(initialForm);
  };

  const closeModal = useCallback(
    (value) => {
      setPayrollModal(value);
      initialModalState();
    },
    [payrollModal]
  );

  const openDeleteRuleModal = useCallback(
    (deleteVal) => {
      setDeleteRuleModal(true);
      setDeleteForm(deleteVal);
    },
    [deleteRuleModal]
  );

  const closeDeleteRuleModal = useCallback(() => {
    setDeleteRuleModal(false);
    setDeleteForm(initialDeleteForm);
  }, [deleteRuleModal]);

  const editPayrollHandler = (freq) => {
    closeModal(true);
    const editValues = {
      id: freq?.id ?? "",
      payroll_name: freq?.payroll_name ?? "",
      payroll_frequency_id: freq?.payroll_frequency_id ?? "",
      interim_period_ending_date:
        freq?.interim_period_ending_date &&
        freq?.interim_period_ending_date != 0
          ? freq?.interim_period_ending_date
          : "",
      final_period_ending_date: freq?.final_period_ending_date ?? "",
    };
    setInputForm(editValues);
    reset(editValues);
  };

  const submitForm = (data) => {
    // console.log("submitForm", data);
    dispatch(savePayrollFreq(data));
    closeModal(false);
  };

  const submitNextHandler = (isLogout = false) => {
    const selectedRuleArr = [];
    if (selectedRules && selectedRules?.length > 0) {
      selectedRules?.map((rule) => {
        selectedRuleArr.push(rule.value);
      });
    }
    dispatch(
      saveSetupWizardForm("three", { labor_policy_rules: selectedRuleArr })
    );
  };

  const deleteSubmitForm = () => {
    // console.log("deleteSubmitForm", deleteForm);
    dispatch(deleteLaborRule(deleteForm));
    closeDeleteRuleModal();
  };

  const checkRuleExist = (rule) => {
    return selectedRules.findIndex((p) => p.value == rule) > -1 ? true : false;
  };

  return (
    <SWInterface step={3}>
      <div className="steps-content row_count2">
        <div className="steps-div_outer">
          <div className="steps-div d-block">
            <form id="form_step_two">
              <h4 className="event-alert mb-0"> Labor Settings </h4>
              <p class="mt-0">
                Take this opportunity to setup your business core Labor Policy
                settings to help GoGMGo get you up and running Day 1.
              </p>

              <div class="row-fluid other_input">
                <h4 class="sm-hd"> Payroll Settings </h4>
                <div class="table-responsive inner-space screen-scroll">
                  <table class="table checklist-table remove-space inventory_table">
                    <thead>
                      <tr>
                        <th> Payroll Name / Frequency </th>
                        <th> Interim Period Ending Date </th>
                        <th> Final Period Ending Date </th>
                        <th className="action-td"> Actions </th>
                      </tr>
                    </thead>
                    <tbody>
                      {totalFrequencies &&
                        totalFrequencies?.length > 0 &&
                        totalFrequencies.map((freq, index) => {
                          return (
                            <tr>
                              <td>
                                <b>{freq?.payroll_name ?? "-"}</b> <br />
                                {payrollFrequencies?.[
                                  freq?.payroll_frequency_id
                                ] ?? "-"}
                              </td>
                              <td>
                                {freq?.payroll_frequency_id == 1
                                  ? `${freq?.interim_period_ending_date} of the Month`
                                  : ""}
                              </td>
                              <td>
                                {" "}
                                {freq?.final_period_ending_date == 0
                                  ? `Last day of the Month`
                                  : `${freq?.final_period_ending_date} of the Month`}
                              </td>
                              <td className="action-td">
                                <a
                                  onClick={() => editPayrollHandler(freq)}
                                  className="editFrequency circle_icon"
                                >
                                  <i className="iconSprites edit-icon"></i>
                                </a>
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
                <div class="my-3">
                  <a
                    class="btn green-btn-revert add-plus "
                    onClick={() => closeModal(true)}
                  >
                    <i class="i-icon"> </i> Add Payroll Frequency
                  </a>
                </div>

                <h4 className="event-alert mb-0 mt-5"> Labor Policy Rules</h4>
                <div className="row mx-0 py-3 justify-content-between">
                  <p class="mt-0 px-0 col-3">
                    Which Rule Types would you like to setup now?
                  </p>
                  <div class="col-9">
                    <Select
                      className="w-100"
                      onChange={(values) => {
                        setSelectedRules(values);
                      }}
                      options={rulesArr}
                      value={selectedRules}
                      isMulti
                    />
                  </div>
                </div>

                {checkRuleExist("leave_claim") && (
                  <LeaveRule openDeleteRuleModal={openDeleteRuleModal} />
                )}
                {checkRuleExist("overtime") && (
                  <OvertimeRule openDeleteRuleModal={openDeleteRuleModal} />
                )}
                {checkRuleExist("allowance") && (
                  <AllowanceRule openDeleteRuleModal={openDeleteRuleModal} />
                )}
                {checkRuleExist("black_out") && (
                  <BlackOutDateRanges
                    openDeleteRuleModal={openDeleteRuleModal}
                  />
                )}
                {checkRuleExist("incentive") && (
                  <IncentiveRule openDeleteRuleModal={openDeleteRuleModal} />
                )}
                {checkRuleExist("performance") && (
                  <PerformanceRule openDeleteRuleModal={openDeleteRuleModal} />
                )}

                <h4 className="sm-hd light mt-5"> Work Week Days </h4>

                <div class="table-responsive inner-space screen-scroll">
                  {work_weeks && work_weeks.length > 0 && (
                    <Paginate
                      head={
                        <tr>
                          <th> Payroll Name &amp; Frequency </th>
                          <th> Start Date </th>
                          <th> End Date </th>
                          <th> Calendar Days </th>
                          <th> # of Sundays </th>
                          <th> # of Saturdays </th>
                          <th> 5 Days/Week </th>
                          <th> 5.5 Days/Week </th>
                          <th> 6 Days/Week </th>
                        </tr>
                      }
                      data={work_weeks}
                    />
                  )}
                  {/* <tr>
                        <td>
                          <b>kdfdf</b> <br /> Bi-Weekly
                        </td>
                        <td> 19/03/2022 </td>
                        <td> 04/04/2022 </td>
                        <td> 17 </td>
                        <td> 3 </td>
                        <td> 3 </td>
                        <td> 11 </td>
                        <td> 12.5 </td>
                        <td> 14 </td>
                      </tr> */}
                </div>
              </div>
              <BtmButtons submitHandler={submitNextHandler} />
            </form>
          </div>
        </div>
      </div>
      <ModelContainer
        title={`Add Payroll Frequency`}
        open={payrollModal}
        closeModal={closeModal}
        submitModal={handleSubmit(submitForm)}
        is_loading={false}
      >
        <form>
          {console.log("Errors", errors)}
          <div className="form-list">
            <ul className="px-0">
              <li>
                <label className="required"> Payroll Name </label>
                <div className="input-group mb10">
                  <input
                    {...register("payroll_name")}
                    className="required"
                    type="text"
                    id="PayrollFrequencyPayrollName"
                    onChange={(event) =>
                      changeInputHandler("payroll_name", event?.target?.value)
                    }
                    value={inputForm?.payroll_name}
                  />
                  <ErrorContainer errors={errors} name="payroll_name" />
                </div>
              </li>
              <li>
                <label className="required"> Frequency </label>
                <div className="input-wrap select-div">
                  <select
                    {...register("payroll_frequency_id")}
                    name="payroll_frequency_id"
                    className="required changing"
                    onChange={(event) =>
                      changeInputHandler(
                        "payroll_frequency_id",
                        event?.target?.value
                      )
                    }
                    disabled={inputForm?.id !== ""}
                    value={inputForm?.payroll_frequency_id}
                  >
                    <option value=""> Select Frequency </option>
                    {payrollFrequencies &&
                      payrollFrequencies !== null > 0 &&
                      Object.keys(payrollFrequencies).map((index) => {
                        return (
                          <option value={index} key={index}>
                            {" "}
                            {payrollFrequencies?.[index]}{" "}
                          </option>
                        );
                      })}
                  </select>
                  <ErrorContainer errors={errors} name="payroll_frequency_id" />
                </div>
              </li>
              {inputForm?.payroll_frequency_id == 1 && (
                <li>
                  <label className="required">
                    {" "}
                    Interim Period Ending Date{" "}
                  </label>
                  <div className="input-wrap select-div">
                    <select
                      {...register("interim_period_ending_date")}
                      name="interim_period_ending_date"
                      className="required changing"
                      onChange={(event) =>
                        changeInputHandler(
                          "interim_period_ending_date",
                          event?.target?.value
                        )
                      }
                      disabled={inputForm?.id !== ""}
                      value={inputForm?.interim_period_ending_date}
                    >
                      <option value=""> Select Period Ending Date </option>
                      {period1EndingDates &&
                        period1EndingDates !== null > 0 &&
                        Object.keys(period1EndingDates).map((index) => {
                          return (
                            <option value={index} key={index}>
                              {" "}
                              {period1EndingDates?.[index]}{" "}
                            </option>
                          );
                        })}
                    </select>
                    <ErrorContainer
                      errors={errors}
                      name="interim_period_ending_date"
                    />
                  </div>
                </li>
              )}
              {inputForm?.payroll_frequency_id !== "" && (
                <li>
                  <label className="required"> Final Period Ending Date </label>
                  <div className="input-wrap select-div">
                    <select
                      {...register("final_period_ending_date")}
                      name="final_period_ending_date"
                      className="required changing"
                      onChange={(event) =>
                        changeInputHandler(
                          "final_period_ending_date",
                          event?.target?.value
                        )
                      }
                      disabled={inputForm?.id !== ""}
                      value={inputForm?.final_period_ending_date}
                    >
                      <option value=""> Select Period Ending Date </option>
                      {period2EndingDates &&
                        period2EndingDates !== null > 0 &&
                        Object.keys(period2EndingDates).map((index) => {
                          return (
                            <option value={index} key={index}>
                              {" "}
                              {period2EndingDates?.[index]}{" "}
                            </option>
                          );
                        })}
                    </select>
                    <ErrorContainer
                      errors={errors}
                      name="final_period_ending_date"
                    />
                  </div>
                </li>
              )}
            </ul>
          </div>
        </form>
      </ModelContainer>
      <ModelContainer
        title={`Delete Rule`}
        open={deleteRuleModal}
        closeModal={closeDeleteRuleModal}
        submitModal={deleteSubmitForm}
        is_loading={false}
      >
        <p>Are you sure, you want to delete this rule?</p>
      </ModelContainer>
    </SWInterface>
  );
};
export default SetupWizardFour;
